import { render, staticRenderFns } from "./IndustryWarehouse.vue?vue&type=template&id=0eb2970c&scoped=true"
import script from "./IndustryWarehouse.vue?vue&type=script&lang=js"
export * from "./IndustryWarehouse.vue?vue&type=script&lang=js"
import style0 from "./IndustryWarehouse.vue?vue&type=style&index=0&id=0eb2970c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb2970c",
  null
  
)

export default component.exports